var comment_id = {
    local: ['60c8848b7262500001552be3','60c8848e7262500001552be4'],
    op: ['60c8848b7262500001552be3','60c8848e7262500001552be4'],
    rc: ['60c7055d3fb3c80001a07349','60c7055b3fb3c80001a07347'],
    live: ['60c7051f8985620001ae1ac6','60c70521ca3166000188b8fb']
};

var mission_num = $('#tab-mission')[0].dataset.th - 1;

var mission_tab = promokit.tab({
    el: '#tab-mission',
    initActive: mission_num,
    alert: {
        1:(mission_num >= 1 ? false : '추후 공개됩니다.'),
        2:(mission_num >= 2 ? false : '추후 공개됩니다.'),
        3:(mission_num >= 3 ? false : '추후 공개됩니다.')
    }
});

promokit.comment({
    el: '#section-comment1',
    articleId: comment_id[promokit.store('network')][0],
    isMultiCommentArticleId: true
});
promokit.comment({
    el: '#section-comment2',
    articleId: comment_id[promokit.store('network')][1],
    isMultiCommentArticleId: true
});

mission_tab.on('change', (index) => {
    $('.promokit-comment').removeClass('promokit-comment--active');
    $('.p-comment .promokit-comment').eq(index.now).addClass('promokit-comment--active');
});

$(window).on('load',function () {
    $('.p-comment .promokit-comment').eq(mission_num).addClass('promokit-comment--active');
});

let page = promokit.page({
    el:'#p-container',
    type:'basic',
    cnb:true,
    topButton:true,
    footer:{
        theme:'white'
    },
    headerButton: {
        cookie: {
            type: 'year',
            key: 'INDEX_WEB_VISIT_210623_4thanniversary',
            value: false
        },
        home: true,
        event:true,
        sns: true,
        theme: 'black'
    },
    caution:{
        template:
            `<ol>
                <li>미션 이벤트는 로그인 후 참여 가능합니다.</li>
                <li>제재 계정은 당첨이 제한될 수 있습니다.</li>
                <li>미션 이벤트 정답은 이벤트 기간이 종료된 후 공지로 안내될 예정입니다.</li>
                <li>미션 이벤트 및 댓글은 대표 캐릭터로 참여하실 수 있습니다.</li>
                <li>미션 이벤트 보상 및 삭제 일정은 <a href="https://lineagem.plaync.com/board/event/view?articleId=60cca6e056e2e90001e82353"><수상한 개발실 : 미션 이벤트>공지</a>를 통해 확인 가능합니다.</li>
                <li>부정한 방법으로 이벤트에 응모할 경우 당첨에서제외될 수 잇습니다.</li>
                <li>당첨자 발표 및 보상 제공은 별도 공지를 통해 안내드릴 예정이며, 보상 제공을 위해 당첨자 개인정보가 수집될 수 있습니다.</li>
                <li>내부 사정에 따라 이벤트 일정 및 보상 중 일부가 변경될 수 있습니다.</li>
            </ol>`
    }
});

var youtube_tab = promokit.tab({
    el: '#p-slide',
    initActive: 2
});

promokit.youtube({
    el: '.p-slide__item--1',
    youtubeId: 'LR2-HlU6IAM',
    controls: true,
    youtubeLink: true
});
promokit.youtube({
    el: '.p-slide__item--2',
    youtubeId: '_jUpyo32hTc',
    controls: true,
    youtubeLink: true
});
promokit.youtube({
    el: '.p-slide__item--3',
    youtubeId: 'uDI2pUzLKnk',
    controls: true,
    youtubeLink: true
});

$(document).on('click', '.p-bullet__item--1', function(e) {
    e.preventDefault();
    youtube_tab.to($(this).index());
});

$(document).on('click', '.p-bullet__item--2', function(e) {
    e.preventDefault();
    youtube_tab.to($(this).index());
});

$(document).on('click', '.p-bullet__item--3', function(e) {
    e.preventDefault();
    youtube_tab.to($(this).index());
});

$(document).on('click', '.p-sns__item', function(e) {
    e.preventDefault();
    promokit.share({
        target:$(this)[0].innerHTML,
        url: 'https://youtu.be/uDI2pUzLKnk'
    });
});

$(document).on('click', '.p-btn__coupon', function(e) {
    e.preventDefault();
    promokit.coupon();
});



// WEBPACK FOOTER //
// ./src/js/common.js